import React,{useEffect, useState,useRef} from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { useAlert } from '../../../../context/AlertContext';
import kioskCheckinServices from '../kioskCheckinServices';
import KioskHeader from '../../sections/KioskHeader';
import { useReactToPrint } from 'react-to-print';
import { ArrowRight, CalendarMonth, Person, Print, WorkOutline } from '@mui/icons-material';
import moment from 'moment';
import { useKioskConfig } from '../../../../context/KioskConfigContext';
import QRCode from 'react-qr-code';

const MyQrcode = () =>{
  let portald = localStorage.getItem("portalId");;
  const url = "https://me.gtoken.in/portal/"+portald
  return(
    <QRCode
      style={{maxHeight:"1.8in", maxWidth:"1.8in"}}
      value={url}
      className='mb-1'
    />
  )
}


function KioskTokenDetailsPage() {
  const {customerId} = useParams();
  const [tokenDetailList,setTokenDetailList] = useState(null);
  const {AppAlert} = useAlert();
  const getCustomerTokenList = ()=>{
    kioskCheckinServices.getCustomerTokenList(customerId).then(res=>{
        setTokenDetailList(null);
        if(res.data.length > 0){
            setTokenDetailList(res.data)
        }
    }).catch(error=>{
        AppAlert(error.msg,"error");
    }).finally(()=>{
        
    })
  }  

  useEffect(()=>{
    getCustomerTokenList();
  },[])


  const printComponentRef = useRef();
  const navigate = useNavigate();
  const handlePrint = useReactToPrint({
    content: () => printComponentRef.current,
    pageStyle:"@page { size: 2.5in 2.5in; margin: 0; padding:0 }, @media print { @page {  size: 2.5in 2.5in margin: 0mm !important;  body,html{padding:0px;margin:0px;} } }",
    //pageStyle:"@media print { html, body { height: 2.5in; /* Use 100% here to support printing more than a single page*/ margin: 0 !important;padding: 0 !important;overflow: hidden;}}; @page { size: 2.5in 2.5in; margin: 0; }"
    //onAfterPrint:()=>{navigate("/kiosk/dashboard")}
  });

  const [businessInfo] = useKioskConfig();
  useEffect(()=>{
    if(businessInfo.quickPrint == 1 && printComponentRef.current !== undefined){
      console.log("printComponentRef",printComponentRef.current)
      handlePrint();
    }
  },[tokenDetailList,printComponentRef.current,businessInfo])

  return (
    <>
      <div className='container'>
        <div className='row'>
            <KioskHeader />
        </div>
        <div className='row mt-4'>
            <div className='col-md-12'>
              {tokenDetailList?.map((tokenDetails,index) => 
                <div key={tokenDetails.id} className="card mb-2" >
                  <div className="card-body" >  
                      <div className="row mt-2 " ref={printComponentRef}>
                          <div className="col-xs-12 text-center">
                              <div className="rounded  text-center">
                                  <h4 className="mb-0 fw-bold" style={{fontSize:16 }}>{tokenDetails.prefix}-{tokenDetails.tokenNo}</h4>
                              </div>
                          </div>
                          <div className="col-xs-12 text-center">
                                  
                                  {/*tokenDetails.profileImage!== null &&
                                      <img src={tokenDetails.profileImage} className="img-thumbnail"
                                       style={{height:".8in", width:".8in"}}
                                       alt="Visitor Photo" />
                                  */}

                                  <MyQrcode />
                                  <div style={{fontSize:12, lineHeight:0}} ><Person style={{fontSize:12}} />: {tokenDetails.firstName}</div>
                                  <div style={{fontSize:12, lineHeight:0}} ><CalendarMonth style={{fontSize:12}} /> : {moment(tokenDetails.checkinDate).format("LL")} <Print style={{fontSize:12}} /> {moment().format("hh:mm A")}</div>
                                  
                          </div>
                      </div>
                      <div className="col-md-12 mt-3">
                        <span className="float-end me-2">
                          <button type="button" onClick={()=>handlePrint()} className="btn btn-success btn-lg" >Print</button>
                        </span>
                      </div>
                  </div>
                </div>
              )}
            </div>
            <div className="col-md-12 text-center mt-3">
              <Link to={"/kiosk/checkin/"} type="button"  className="btn btn-outline-success btn-lg" >Book Another Token</Link>
            </div>
        </div>
      </div>
    </>
  )
}

export default KioskTokenDetailsPage